// every animation is a css class or keyframe, this just plays them

export function flash(element: HTMLElement): void {
  element.classList.remove("tween-flash");
  // force a reflow so the animation can restart
  void element.offsetWidth;
  element.classList.add("tween-flash");
}

export function setPulsing(element: HTMLElement, pulsing: boolean): void {
  element.classList.toggle("tween-pulse", pulsing);
}

export function setDots(element: HTMLElement, animating: boolean): void {
  element.classList.toggle("tween-dots", animating);
}

// children slot in one after another, only the first time a list fills
export function stagger(container: HTMLElement): void {
  if (container.dataset.staggered) return;
  container.dataset.staggered = "1";
  container.classList.add("slot-in");
  Array.from(container.children).slice(0, 24).forEach((child, index) => {
    (child as HTMLElement).style.setProperty("--index", String(index));
  });
  window.setTimeout(() => container.classList.remove("slot-in"), 900);
}

// a short click on phones that can, nothing elsewhere
export function buzz(ms = 6): void {
  try {
    navigator.vibrate?.(ms);
  } catch {
    // ios safari has no vibrate
  }
}

// every press on a key or button gets a mechanical click down
export function setupPressFeel(): void {
  const selector = "button, .key, .pill, a.pill, .chip, .tile";
  document.addEventListener("pointerdown", (event) => {
    const target = (event.target as Element).closest?.(selector) as HTMLElement | null;
    if (!target || (target as HTMLButtonElement).disabled) return;
    target.classList.add("is-pressed");
    const release = () => {
      target.classList.remove("is-pressed");
      window.removeEventListener("pointerup", release);
      window.removeEventListener("pointercancel", release);
    };
    window.addEventListener("pointerup", release);
    window.addEventListener("pointercancel", release);
  }, { passive: true });
}
